<template>
  <span class="crc-employee-highlight-chip">
    <span
      class="crc-highlight-swatch crc-employee-highlight-chip__swatch"
      :class="{ 'crc-highlight-swatch--default': !hasColor }"
      :style="swatchStyle"
      aria-hidden="true"
    />
    <span v-if="showLabel" class="crc-employee-highlight-chip__label">{{ label }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue';
import {
  EMPLOYEE_HIGHLIGHT_COLORS,
  getEmployeeHighlightLabel,
  getEmployeeHighlightSwatchStyle,
  hasEmployeeHighlight,
  normalizeHighlightColor
} from '@/constants/employeeHighlightColors';

defineOptions({ name: 'EmployeeHighlightChip' });

const props = defineProps({
  color: { type: [String, null], default: '' },
  showLabel: { type: Boolean, default: true }
});

const hasColor = computed(() => hasEmployeeHighlight(props.color));

const label = computed(() => getEmployeeHighlightLabel(props.color));

const swatchStyle = computed(() => {
  if (!hasColor.value) {
    return getEmployeeHighlightSwatchStyle(
      EMPLOYEE_HIGHLIGHT_COLORS.find((opt) => opt.id === 'default')
    );
  }
  const option = EMPLOYEE_HIGHLIGHT_COLORS.find(
    (opt) => normalizeHighlightColor(opt.hex) === normalizeHighlightColor(props.color)
  );
  return getEmployeeHighlightSwatchStyle(option || {
    hex: props.color,
    accent: props.color
  });
});
</script>
